import { createSlice } from '@reduxjs/toolkit';

export const pastCreationSlice = createSlice({
  name: 'pastCreation',
  initialState: {
    pastCreationData: [],
    isPastCreationLoading: false,
    isPastCreationError: false,
    pastCreationErrorMessage: '',
    page: 1,
    previousPage: 0,
    totalDocuments: 0,
    totalPages: 0,
  },
  reducers: {
    setIsVisualizePageVisible: (state, action) => {
      state.isVisualizePageVisible = action.payload;
    },
    setPastCreationLoading: (state, action) => {
      state.isPastCreationLoading = action.payload;
    },
    setPastCreationData: (state, action) => {
      state.pastCreationData = [...state.pastCreationData, ...action.payload.data];
      state.totalDocuments = action.payload.totalDocuments;
      state.previousPage = action.payload.currentpage;
      state.totalPages = action.payload.totalPage;
      // state.isPastCreationLoading = false;
      state.isPastCreationError = false;
      state.pastCreationErrorMessage = '';
    },
    setPastCreationError: (state, action) => {
      state.isPastCreationError = true;
      state.pastCreationErrorMessage = action.payload;
      // state.isPastCreationLoading = false;
    },
    setEmptyPastCreationData: (state) => {
      state.pastCreationData = [];
    },
    setPageNumber: (state, action) => {
      state.page = action.payload;
    },
    setPreviousPage: (state, action) => {
      state.previousPage = action.payload;
    },
    updatePastCreationData: (state, action) => {
      const { promptId, prompt } = action.payload;
      const existingData = state.pastCreationData.find((item) => item.promptId === promptId);

      if (existingData) {
        state.pastCreationData = state.pastCreationData.map(
          (item) =>
            item.promptId === promptId
              ? {
                  ...item, // Ensure existing properties are preserved
                  images: [...item.images, action.payload], // Append the new payload to the images array
                }
              : item, // Keep other items unchanged
        );
      } else {
        state.pastCreationData = [
          {
            promptId,
            prompt,
            images: [action.payload],
          },
          ...state.pastCreationData,
        ];
      }
    },
    updateFeedback(state, action) {
      const { promptId, feedbackData } = action.payload;

      const prompt = state.pastCreationData.find((item) => item.promptId === promptId);

      if (!prompt) return;

      if (prompt) {
        const imageToUpdate = prompt.images.find((image) => image._id === feedbackData._id);

        if (imageToUpdate) {
          imageToUpdate.comment = feedbackData.comment;
          imageToUpdate.feedback1 = feedbackData.feedback1;
          imageToUpdate.feedback2 = feedbackData.feedback2;
          imageToUpdate.feedback3 = feedbackData.feedback3;
          imageToUpdate.rating = feedbackData.rating;
        } else {
          console.error('Image not found for the provided _id:', feedbackData._id);
        }
      }
    },
  },
});

export const {
  setIsVisualizePageVisible,
  setPastCreationLoading,
  setPastCreationError,
  setPastCreationData,
  setEmptyPastCreationData,
  setPageNumber,
  setAppendNewGeneratedImage,
  updateFeedback,
  updatePastCreationData,
  setPreviousPage,
} = pastCreationSlice.actions;

export default pastCreationSlice.reducer;
